import { log } from "@antv/g2plot/lib/utils";
import { types } from "../action-types";

const initialState = {
  loading: false,
  error: false,
  expiry_success: false,
  del_success: false,
  jobs: [],
  response: [],
  jobdetails: [],
  // error: {},
  publishedJobs: [],
  search: false,
  totalLength: false,
  bidDetails: {},
  bidDetailsLoading: false,
  counts: [],
  candidateCounts:[],
  countsLoading: false,
  MostRecentJob: [],
};

const manageJobsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_JOB_LISTING:
      return {
        ...state,
        loading: true,
        search: action.payload.inputSearch != "" ? true : false,
        totalLength: action.payload.totalLength,
        // del_success: false,
      };
    case types.GET_JOB_RESULT_LISTING_SUCCESS:
      return{
        ...state,
        MostRecentJob: action.payload,
      }
    case types.GET_JOB_LISTING_SUCCESS:
      if (state.totalLength) {
        return {
          ...state,
          loading: false,
          jobs: action.payload,
          error: false,
        };  
      }else{
        let combineArr = state.publishedJobs.concat(action.payload.publishedGigs)
        // combineArr.sort((a, b) => moment(b.Created) - moment(a.Created));
        return {
          ...state,
          loading: false,
          jobs: action.payload,
          error: false,
          // publishedJobs: action.payload
          // publishedJobs: [...state.publishedJobs,...action.payload.publishedGigs.filter((item) => item.JobOrderStatuses?.JobOrderStatusName == "Published")],
          publishedJobs: [...new Set(combineArr.filter((item) => item.JobOrderStatuses?.JobOrderStatusName == "Published").map(item => item._id))].map(id => {
            return combineArr.find(item => item._id === id)})
        };
      }
    case types.GET_JOB_LISTING_FAILURE:
      return {
        ...state,
        loading: false,
        jobs: [],
        error: true,
      };
    case types.GET_JOB_LISTING_RESET:
      return {
        ...state,
        jobs: [],
        publishedJobs: [],
      };

    // fetchAlGigs reducer
    // case types.FETCH_GIGSALL_REQUESTED:
    //     return {
    //         ...state,
    //         loading: true,
    //         expiry_success: false,
    //         del_success: false,
    //         response: [],
    //         jobs: [],
    //     };

    // case types.FETCH_GIGSALL_SUCCESS:
    //     return {
    //         ...state,
    //         loading: false,
    //         jobs: action.payload,
    //         del_success: false,
    //         expiry_success: false,
    //         error: false,
    //     };
    // case types.FETCH_GIGSALL_FAILURE:
    //     return {
    //         ...state,
    //         loading: false,
    //         jobs: [],
    //         error: true,
    //     };

    // getJobdetails reducer
    case types.GET_JOBDETAIL_REQUESTED:
      return {
        ...state,
        loading: true,
        expiry_success: false,
      };

    case types.CLEAR_JOB_DELETE_SUCCESS:
      return {
        ...state,
        del_success: false,
        response: [],
      };

    case types.GET_JOBDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        jobdetails: action.payload,
        error: false,
      };
    case types.GET_JOBDETAIL_FAILURE:
      return {
        ...state,
        loading: false,
        jobdetails: [],
        error: true,
      };

    // updateJob reducer
    case types.UPDATE_GIG_REQUESTED:
      return {
        ...state,
        loading: true,
        expiry_success: false,
        del_success: false,
      };

    case types.UPDATE_GIG_SUCCESS:
      return {
        ...state,
        loading: false,
        expiry_success: true,
        error: false,
        response: action.payload,
      };
    case types.UPDATE_GIG_FAILURE:
      return {
        ...state,
        loading: false,
        expiry_success: false,
        error: true,
      };

    // deleteJob reducer

    case types.DELETE_JOB_REQUESTED:
      return {
        ...state,
        loading: true,
        expiry_success: false,
        del_success: false,
      };

    case types.DELETE_JOB_SUCCESS:
      const updatedGig = action.payload?.updatedGig ?? null
      let newJobsData = [...state.jobs.publishedGigs]
      if (updatedGig) {
        const index = newJobsData.findIndex(e => e.JobOrderId === updatedGig.JobOrderId)
        if (index !== -1) newJobsData[index] = { ...updatedGig }
      }
      return {
        ...state,
        loading: false,
        expiry_success: false,
        del_success: true,
        error: false,
        response: action.payload,
        jobs: { publishedGigs: [...newJobsData] }
      };
    case types.DELETE_JOB_FAILURE:
      return {
        ...state,
        loading: false,
        // del_success: false,
        expiry_success: false,
        error: true,
        response: [],
      };
    case types.GET_JOB_BID_DETAILS:
      return {
        ...state,
        bidDetailsLoading: true,
      };
    case types.GET_JOB_BID_SUCCESS:
      return {
        ...state,
        bidDetails: action.payload,
        bidDetailsLoading: false,
      };

    case types.GET_JOB_COUNTS_REQUESTED:
      return {
        ...state,
        countsLoading: true,
        search: action.payload.inputSearch != "" ? true : false,
      };
    case types.GET_JOB_COUNTS_SUCCESS:
      return {
        ...state,
        countsLoading: false,
        counts: action.payload,
        error: false,
      };
    case types.GET_JOB_COUNTS_FAILURE:
      return {
        ...state,
        countsLoading: false,
        error: true,
      };

      case types.GET_CANDIDATE_COUNTS_REQUESTED:
        return {
          ...state,
          candidateCountsLoading: true,
          candidateSearch: action.payload.inputSearch != "" ? true : false,
        };
      case types.GET_CANDIDATE_COUNTS_SUCCESS:
        return {
          ...state,
          candidateCountsLoading: false,
          candidateCounts: action.payload,
          candidateError: false,
        };
      case types.GET_CANDIDATE_COUNTS_FAILURE:
        return {
          ...state,
          candidateCountsLoading: false,
          candidateError: true,
        };

    // default case
    default:
      return state;
  }
};

export default manageJobsReducer;
